// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ngw-pyramid-avatar {
  cursor: pointer;
  user-select: none;
}
.ngw-pyramid-avatar > a {
  font-weight: var(--ngw-text-font-weight-bold);
  font-size: 16px;
  text-decoration: none;
}
.ngw-pyramid-avatar-label {
  display: inline-block;
  vertical-align: middle;
  border-radius: 2px;
  background: var(--primary);
  width: 32px;
  height: 32px;
  color: var(--on-primary-text);
  font-size: 20px;
  line-height: 32px;
  text-align: center;
}
.ngw-pyramid-avatar-danger .ngw-pyramid-avatar-label {
  background-color: var(--surface-bg-danger);
  color: var(--on-primary);
}
.ngw-pyramid-avatar-popover .ant-popover-content > .ant-popover-inner {
  padding: 1ex;
}
.ngw-pyramid-avatar-popover .ant-popover-content > .ant-popover-inner .ant-popover-title {
  padding: 4px 8px;
}
.ngw-pyramid-avatar-popover .ant-popover-content > .ant-popover-inner .ant-popover-inner-content {
  display: flex;
  flex-direction: column;
  gap: 1ex;
  padding: 0px;
}
.ngw-pyramid-avatar-popover .ant-popover-content > .ant-popover-inner .ant-popover-inner-content div.warning {
  background-color: var(--surface-bg-danger);
  padding: 4px 8px;
}
.ngw-pyramid-avatar-popover .ant-popover-content > .ant-popover-inner .ant-popover-inner-content a {
  display: block;
  padding: 4px 8px;
  color: var(--text-base);
  text-decoration: none;
}
.ngw-pyramid-avatar-popover .ant-popover-content > .ant-popover-inner .ant-popover-inner-content a:hover {
  background-color: rgba(0, 0, 0, 0.04);
}
`, "",{"version":3,"sources":["webpack://./package/nextgisweb/nextgisweb/pyramid/nodepkg/layout/Avatar.less"],"names":[],"mappings":"AAAA;EACI,eAAA;EACA,iBAAA;AACJ;AAHA;EAKQ,6CAAA;EACA,eAAA;EACA,qBAAA;AACR;AAEI;EACI,qBAAA;EACA,sBAAA;EACA,kBAAA;EACA,0BAAA;EACA,WAAA;EACA,YAAA;EACA,6BAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;AAAR;AAIA;EAEQ,0CAAA;EACA,wBAAA;AAHR;AAOA;EAGY,YAAA;AAPZ;AAIA;EAMgB,gBAAA;AAPhB;AACA;EAUgB,aAAA;EACA,sBAAA;EACA,QAAA;EACA,YAAA;AARhB;AALA;EAgBoB,0CAAA;EACA,gBAAA;AARpB;AATA;EAqBoB,cAAA;EACA,gBAAA;EACA,uBAAA;EACA,qBAAA;AATpB;AAWoB;EACI,qCAAA;AATxB","sourcesContent":[".ngw-pyramid-avatar {\n    cursor: pointer;\n    user-select: none;\n\n    > a {\n        font-weight: bold;\n        font-size: 16px;\n        text-decoration: none;\n    }\n\n    &-label {\n        display: inline-block;\n        vertical-align: middle;\n        border-radius: 2px;\n        background: var(--primary);\n        width: 32px;\n        height: 32px;\n        color: var(--on-primary-text);\n        font-size: 20px;\n        line-height: 32px;\n        text-align: center;\n    }\n}\n\n.ngw-pyramid-avatar-danger {\n    .ngw-pyramid-avatar-label {\n        background-color: var(--surface-bg-danger);\n        color: var(--on-primary);\n    }\n}\n\n.ngw-pyramid-avatar-popover {\n    .ant-popover-content {\n        > .ant-popover-inner {\n            padding: 1ex;\n\n            .ant-popover-title {\n                padding: 4px 8px;\n            }\n\n            .ant-popover-inner-content {\n                display: flex;\n                flex-direction: column;\n                gap: 1ex;\n                padding: 0px;\n\n                div.warning {\n                    background-color: var(--surface-bg-danger);\n                    padding: 4px 8px;\n                }\n\n                a {\n                    display: block;\n                    padding: 4px 8px;\n                    color: var(--text-base);\n                    text-decoration: none;\n\n                    &:hover {\n                        background-color: rgba(0, 0, 0, 0.04);\n                    }\n                }\n            }\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
